import { render, staticRenderFns } from "./messageLetter.vue?vue&type=template&id=e3f4c26a&"
import script from "./messageLetter.vue?vue&type=script&lang=js&"
export * from "./messageLetter.vue?vue&type=script&lang=js&"
import style0 from "./messageLetter.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports